export const CHECK_FOR_SIGNEDIN_USER_COMMAND = 'CheckForSignedInUserCommand';
export const OPEN_SIGNIN_DIALOG_COMMAND = 'OpenSigninDialogCommand';
export const SIGNIN_COMPLETE_EVENT = 'SigninCompleteEvent';
export const SIGNOUT_COMMAND = 'SignoutCommand';
export const SIGNOUT_COMPLETE_EVENT = 'SignoutCompleteEvent';
